import React from 'react';
import { Button, ButtonProps } from 'reactstrap';
import {
  LoadingSpinnerIcon,
  PropTypes as LoadingSpinnerIconPropTypes,
} from '../LoadingSpinnerIcon';

interface PropTypes extends ButtonProps {
  isLoading: boolean;
  loadingSpinnerProps?: LoadingSpinnerIconPropTypes;
  children: React.ReactNode;
}

export function LoadingButton(props: PropTypes) {
  const { isLoading, loadingSpinnerProps, children, ...buttonProps } = props;
  return (
    <Button {...buttonProps} disabled={buttonProps.disabled ?? isLoading}>
      {isLoading && (
        <LoadingSpinnerIcon className={'me-2'} {...loadingSpinnerProps} />
      )}
      {children}
    </Button>
  );
}
